import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=1c3dbf50&scoped=true"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=1c3dbf50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dbf50",
  null
  
)

export default component.exports